const AB_DESKTOP = window.matchMedia('(min-width: 990px)');

class ABMegaMenu {
  constructor() {
    this.items = [...document.querySelectorAll('.menu-list__list-item')].filter(
      (item) => item.querySelector(':scope > .ab-mega-menu')
    );
    this.active = null;
    this.timer = null;
    this.backdrop = this.createBackdrop();

    this.items.forEach((item) => this.bind(item));
    window.addEventListener('resize', () => this.positionMenus());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll(true);
    });
  }

  createBackdrop() {
    let backdrop = document.querySelector('.ab-menu-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'ab-menu-backdrop';
      document.body.appendChild(backdrop);
    }
    backdrop.addEventListener('pointerenter', () => this.closeAll());
    return backdrop;
  }

  bind(item) {
    const trigger = item.querySelector(':scope > .menu-list__link');
    const menu = item.querySelector(':scope > .ab-mega-menu');
    if (!trigger || !menu) return;

    trigger.setAttribute('aria-controls', menu.id);
    trigger.setAttribute('aria-expanded', 'false');

    const open = () => {
      if (!AB_DESKTOP.matches) return;
      clearTimeout(this.timer);
      this.open(item, trigger, menu);
    };

    const scheduleClose = () => {
      clearTimeout(this.timer);
      this.timer = window.setTimeout(() => {
        if (!item.matches(':hover') && !menu.matches(':hover')) {
          this.close(item, trigger, menu);
        }
      }, 220);
    };

    item.addEventListener('pointerenter', open);
    item.addEventListener('pointerleave', scheduleClose);
    menu.addEventListener('pointerenter', () => clearTimeout(this.timer));
    menu.addEventListener('pointerleave', scheduleClose);
    trigger.addEventListener('focus', open);
    trigger.addEventListener('click', (event) => {
      if (!AB_DESKTOP.matches) return;
      if (trigger.getAttribute('aria-expanded') !== 'true') {
        event.preventDefault();
        open();
      }
    });
    menu.addEventListener('focusin', () => clearTimeout(this.timer));
    menu.addEventListener('focusout', scheduleClose);
  }

  open(item, trigger, menu) {
    if (this.active && this.active !== item) {
      const oldTrigger = this.active.querySelector(':scope > .menu-list__link');
      const oldMenu = this.active.querySelector(':scope > .ab-mega-menu');
      this.close(this.active, oldTrigger, oldMenu);
    }

    this.active = item;
    this.positionMenus();
    trigger.setAttribute('aria-expanded', 'true');
    menu.dataset.open = 'true';
    menu.setAttribute('aria-hidden', 'false');
    menu.querySelectorAll('a').forEach((link) => link.removeAttribute('tabindex'));
    this.backdrop.dataset.open = 'true';
  }

  close(item, trigger, menu, restoreFocus = false) {
    if (!item || !trigger || !menu) return;
    trigger.setAttribute('aria-expanded', 'false');
    delete menu.dataset.open;
    menu.setAttribute('aria-hidden', 'true');
    menu.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));

    if (this.active === item) {
      this.active = null;
      delete this.backdrop.dataset.open;
    }

    if (restoreFocus) trigger.focus();
  }

  closeAll(restoreFocus = false) {
    this.items.forEach((item) => {
      const trigger = item.querySelector(':scope > .menu-list__link');
      const menu = item.querySelector(':scope > .ab-mega-menu');
      this.close(item, trigger, menu, restoreFocus && item === this.active);
    });
  }

  positionMenus() {
    const header = document.querySelector('#header-component');
    if (!header) return;
    const rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--ab-mega-menu-top', `${Math.max(rect.bottom, 0)}px`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.ab-mega-menu')) new ABMegaMenu();
});
